module.exports = __webpack_public_path__ + "img/selfCheck.2df9ff6f.png";